import { ProgrammePage } from "@/components/site/ProgrammePage";

export default function Ijmb() {
  return (
    <ProgrammePage
      code="IJMB"
      title="IJMB Programme"
      subtitle="An alternative advanced-level pathway for students preparing for higher education opportunities."
      intro="IJMB (Interim Joint Matriculation Board) is an alternative advanced-level programme providing structured academic preparation and a recognised examination. It offers eligible candidates another credible route toward Direct Entry opportunities."
      blocks={[
        { t: "What IJMB Is", d: "An advanced-level foundation programme with a recognised examination used to pursue eligible Direct Entry opportunities." },
        { t: "Who Should Consider It", d: "Candidates seeking an alternative advanced-level pathway toward higher education, including those who did not sit for or secure UTME admission." },
        { t: "Programme Structure", d: "Structured lessons across a defined subject combination aligned to the candidate's intended course area." },
        { t: "Duration", d: "The programme duration is configurable per academic session. Confirm the current duration with the admissions office." },
        { t: "Academic Preparation", d: "Quality teaching and mentorship that build the discipline and confidence required for university-level study." },
        { t: "Examination", d: "Candidates prepare for and sit the IJMB examination administered under its examination body." },
        { t: "Direct Entry Pathway", d: "Successful candidates may pursue eligible Direct Entry opportunities into 200 Level, subject to the receiving institution's requirements." },
        { t: "Admission Considerations", d: "Available pathways depend on subject combination, chosen programme, receiving institution and applicable admission requirements." },
      ]}
      seo={{
        title: "IJMB Programme | IAUE School of Basic Studies, Port Harcourt",
        description: "IJMB advanced-level programme at the School of Basic Studies, IAUE Port Harcourt — structure, examination and eligible Direct Entry pathway into 200 Level.",
      }}
    />
  );
}
